import { render, staticRenderFns } from "./SquadTagger.vue?vue&type=template&id=2af6be4a&scoped=true"
import script from "./SquadTagger.vue?vue&type=script&lang=js"
export * from "./SquadTagger.vue?vue&type=script&lang=js"
import style0 from "./SquadTagger.vue?vue&type=style&index=0&id=2af6be4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6be4a",
  null
  
)

export default component.exports